var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { OnInit, ElementRef } from '@angular/core';
import { HttpClientModule } from "@angular/common/http";
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { PayeeSubmission } from '../../shared/sdk/models';
import { PayeeApi, StorageApi, PayeeSubmissionApi } from '../../shared/sdk/services';
import { GlobalEventsManager } from '../../events-manager.component';
import { SubmissionDetailService } from "../../shared/app/services/";
import { LoopBackConfig } from "../../shared/sdk/lb.config";
var ɵ0 = window;
var M2UPayOfferLetterComponent = /** @class */ (function () {
    function M2UPayOfferLetterComponent(payeeApi, payeeSubmissionApi, router, storageApi, eventsManager, submissionDetailService, sanitizer, http, document) {
        this.payeeApi = payeeApi;
        this.payeeSubmissionApi = payeeSubmissionApi;
        this.router = router;
        this.storageApi = storageApi;
        this.eventsManager = eventsManager;
        this.submissionDetailService = submissionDetailService;
        this.sanitizer = sanitizer;
        this.http = http;
        this.document = document;
        this.TAG = "M2UPayOfferLetterComponent";
    }
    // Initialisation
    M2UPayOfferLetterComponent.prototype.ngOnInit = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                // console.log(this.TAG + "getOfferLetter: ");
                this.getOfferLetter().subscribe(function (res) {
                    _this.eventsManager.loaded(true);
                    console.log(_this.TAG + "res: ");
                    console.log(res);
                    if (res.attachments.length > 0) {
                        for (var _i = 0, _a = res.attachments; _i < _a.length; _i++) {
                            var attachment = _a[_i];
                            switch (attachment.type) {
                                case "maybank2uPay_offer_letter":
                                    _this.offerletterSrc = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
                                        "/storages/" + _this.payeeApi.getCurrentId() + "/download/" + attachment.file_name +
                                        "?access_token=" + _this.payeeApi.getCurrentToken().id;
                                    break;
                                case "maybank2uPay_service_agreement":
                                    _this.serviceAgreementSrc = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
                                        "/storages/" + _this.payeeApi.getCurrentId() + "/download/" + attachment.file_name +
                                        "?access_token=" + _this.payeeApi.getCurrentToken().id;
                                    break;
                            }
                        }
                        _this.authLetterCollectionAccSrc = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() + "/storages/doc/download/Letter_of_Authorisation_Collection_Account_template.docx" + "?access_token=" + _this.payeeApi.getCurrentToken().id;
                        ;
                    }
                }, function (err) {
                    _this.eventsManager.loaded(true);
                    console.log(err);
                    _this.router.navigate(['/dashboard']);
                });
                return [2 /*return*/];
            });
        });
    };
    M2UPayOfferLetterComponent.prototype.getOfferLetter = function () {
        var filter = {
            include: [{
                    relation: "attachments",
                    scope: {
                        where: {
                            "or": [
                                {
                                    'type': "maybank2uPay_service_agreement",
                                    'isDeleted': false
                                },
                                {
                                    'type': "maybank2uPay_offer_letter",
                                    'isDeleted': false
                                },
                            ]
                        },
                        include: "detail",
                        order: 'created_at ASC'
                    }
                },
                {
                    relation: "submission_subtags",
                    scope: {
                        where: {
                            'deleted_at': null
                        }
                    }
                }
            ]
        };
        return this.payeeSubmissionApi.findById(this.submissionDetailService.getCurrentSubmissionId(), filter);
    };
    M2UPayOfferLetterComponent.prototype.populateFormData = function () {
        this.eventsManager.loaded(true);
        // this.payeeApi.getCmoWebChecklist(this.payeeApi.getCurrentId(), {
        //   // where: {'merchant_to_review': 1},
        //   order:'created_at DESC',
        //   include:{
        //     "relation": "adminChecklist",
        //     "scope": {
        //         "include": ["remarks"]
        //   }
        // }}).subscribe(
        //   checklists => {
        //     console.log(checklists);
        //     if (checklists.length == 0) {
        //       this.details.payee_id = this.payeeApi.getCurrentId();
        //     } else {
        //         this.details = checklists[0];
        //         this.adminChecklist = checklists[0].adminChecklist;
        //         this.adminChecklistRemark = checklists[0].adminChecklist.remarks;
        //     }
        //     this.eventsManager.loaded(true);
        //   },
        //   err => {
        //     console.log(err);
        //     this.eventsManager.logout(true);
        //     this.eventsManager.showPopUp("Your session has expired. Please login.");
        //     this.eventsManager.loaded(true);
        //   }
        // );
    };
    M2UPayOfferLetterComponent.prototype.addEventListeners = function () { };
    M2UPayOfferLetterComponent.prototype.downloadPDF = function (file) {
        switch (file) {
            case "offerLetter":
                this.offerLetter.nativeElement.click();
                break;
            case "serviceAgreement":
                this.serviceAgreement.nativeElement.click();
                break;
            case "authLetterCollectionAcc":
                this.authLetterCollectionAcc.nativeElement.click();
                break;
        }
        // var win = open(this.mobileSrc,'windowName','height=300,width=300');
        // win.document.write("");
        // window.open(this.mobileSrc);
        // this.download(this.file_name);
        // let url=this.mobileSrc;
        // this.http.get(url).map(
        //     (res) => {
        //         console.log(res);
        //         return new Blob([res.blob()], { type: 'application/pdf' })
        //     })
    };
    // Scrolling
    M2UPayOfferLetterComponent.prototype.scrollToTop = function () {
        window.scroll(0, 0);
        document.body.getElementsByClassName('scroll_checklist')[0].scrollTop = 0;
    };
    M2UPayOfferLetterComponent.prototype.scrollToSave = function () {
        document.body.getElementsByClassName('scroll_checklist')[0].scrollTop = document.getElementById('save_checklist').offsetTop;
    };
    return M2UPayOfferLetterComponent;
}());
export { M2UPayOfferLetterComponent };
export { ɵ0 };
